<template>

    <div class="surface-ground">
        <div class="flex flex-row justify-content-start">

            <div class="flex-auto pr-2 max-w-30rem" v-for="pairData in menuData" @click="goToPair(pairData.symbol)">
                <div class="surface-card p-3 border-round cursor-pointer hover:bg-blue-50" :class="{'shadow-1': currentPairSymbol===pairData.symbol, 'shadow-3': currentPairSymbol!==pairData.symbol}">
                    <div class="flex justify-content-between mb-3">
                        <div class="text-600">
                            <span class="block text-600 font-medium mb-3" v-if="pairData.symbol === 'ALL'">Все пары</span>
                            <span class="block text-600 font-medium mb-3" v-else>{{pairData.symbol}}</span>
                            <span v-if="pairData.todayProfitValue > 0">
                                <span class="text-green-500 font-medium text-xl">${{pairData.todayProfitValue}}</span>
<!--                                <span class="text-green-500">{{pairData.todayProfitPercent}}%</span>-->
                            </span>
                            <span v-if="pairData.todayProfitValue < 0">
                                <span class="text-red-500 font-medium text-xl">${{pairData.todayProfitValue}}</span>
<!--                                <span class="text-red-500">{{pairData.todayProfitPercent}}%</span>-->
                            </span>
                            <span v-if="pairData.todayProfitValue === 0">
                                <span class="text-500 font-medium text-xl">$0</span>
                            </span>
                            <span class="text-500 ml-1">объём ${{pairData.todayDealsValue}} за {{pairData.todayClosedDeals}} сделок</span>
                        </div>
                        <div class="flex align-items-center justify-content-center full-rounded" style="width:2.5rem;height:2.5rem">
                            <img v-if="pairData.symbol !== 'ALL'" :src="'/logos/'+pairData.base+'.svg'" style="width:2.5rem;height:2.5rem" class="full-rounded" :alt="pairData.symbol"/>
                        </div>
                    </div>
                    <template v-if="pairData.yesterdayProfitValue > 0">
                        <span class="font-medium text-base text-500">
                            <span class="text-green-500">${{pairData.yesterdayProfitValue}}</span>
                        </span>
                    </template>
                    <template v-if="pairData.yesterdayProfitValue < 0">
                        <span class="font-medium text-base text-500">
                            <span class="text-red-500">${{pairData.yesterdayProfitValue}}</span>
                        </span>
                    </template>
                    <template v-if="pairData.yesterdayProfitValue === 0">
                        <span class="font-medium text-base text-500">
                            ${{pairData.yesterdayProfitValue}}
                        </span>
                    </template>
                    <span class="text-500 ml-1">${{pairData.yesterdayDealsValue}}/{{pairData.yesterdayClosedDeals}} за вчера</span>
                </div>
            </div>

        </div>
    </div>

</template>
<script>
import BtcLogo from "@/Logos/BtcLogo";
import EthLogo from "@/Logos/EthLogo";
export default {
    components: {BtcLogo, EthLogo},
    props:{
        pairsData: Array,
        currentPairSymbol: String,
        menuPairs: String,
        url: String
    },
    data(){
        return {
            //menuItems: ["ALL", "BTCUSDT", "ETHUSDT", "BNBUSDT", "SOLUSDT", "ADAUSDT", "XRPUSDT", "TRXUSDT"],
        }
    },
    computed:{
        menuData(){
            let menuPairsArray = this.menuPairs.split(',');
            return menuPairsArray.map(pairSymbol=>{
                let pairData = this.pairsData.find(pair=>pair.symbol===pairSymbol);
                return {
                    symbol: pairSymbol,
                    name: pairData.name,
                    base: pairData.base,
                    profitValue: pairData.profitValue,
                    profitPercent: pairData.profitPercent,

                    todayProfitValue: pairData.todayProfitValue,
                    todayProfitPercent: pairData.todayProfitPercent,
                    todayDealsValue: pairData.todayDealsValue,
                    todayClosedDeals: pairData.todayClosedDeals,

                    yesterdayProfitValue: pairData.yesterdayProfitValue,
                    yesterdayProfitPercent: pairData.yesterdayProfitPercent,
                    yesterdayDealsValue: pairData.yesterdayDealsValue,
                    yesterdayClosedDeals: pairData.yesterdayClosedDeals,
                }
            })
        }
    },
    methods:{
        goToPair(pairSymbol){
            if(this.url) this.$inertia.get('/'+this.url+'/'+pairSymbol);
        }
    }

}
</script>
